import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { agree_support_request, fetch_my_support_requests, open_support_request, type Side } from './api';

const key = (side: Side) => ['support-requests', side] as const;

export function use_my_support_requests(side: Side) {
  return useQuery({ queryKey: key(side), queryFn: () => fetch_my_support_requests(side), staleTime: 10_000 });
}

export function use_support_mutations(side: Side) {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: key(side) });
    // A resolved reschedule/reassign moves the booking, so refresh the booking lists too.
    qc.invalidateQueries({ queryKey: ['bookings'] });
    qc.invalidateQueries({ queryKey: ['vendor', 'bookings'] });
  };

  const open = useMutation({
    mutationFn: ({ booking_id, reason }: { booking_id: string; reason?: string }) => open_support_request(side, booking_id, reason),
    onSuccess: invalidate,
  });
  const agree = useMutation({
    mutationFn: (booking_id: string) => agree_support_request(side, booking_id),
    onSuccess: invalidate,
  });

  return { open, agree };
}
